import React from 'react';
import styled from 'styled-components';
import { REPOSIT_PRIVACY_POLICY } from '../../constants/links';
import { MARKETING_CONSENT_CHANNELS, MARKETING_CONSENT_STATEMENT } from '../../constants/marketing-consent-statement';
import { MarketingPreferenceChoice } from '../../utils/marketing-preferences';
import Checkbox from '../FormFields/Checkbox';
import RepositCard from '../RepositCard';
import { P2, P3 } from '../Typography';

interface MarketingPreferencesCardProps {
  value: MarketingPreferenceChoice;
  onChange: (value: MarketingPreferenceChoice) => void;
  children?: JSX.Element;
}

const Channels = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 1rem;
`;

const Footnote = styled(P3)`
  margin-bottom: 0;

  a {
    color: ${(props) => props.theme.colors.primaryBrand};
  }
`;

const MarketingPreferencesCard: React.FC<MarketingPreferencesCardProps> = ({ value, onChange, children }) => (
  <RepositCard title={MARKETING_CONSENT_STATEMENT.heading}>
    <P2>{MARKETING_CONSENT_STATEMENT.text}</P2>
    <Channels>
      {MARKETING_CONSENT_CHANNELS.map(({ key, label }) => (
        <Checkbox
          key={key}
          name={`marketingPreferences.${key}`}
          label={label}
          isChecked={value[key]}
          onChange={() => onChange({ ...value, [key]: !value[key] })}
        />
      ))}
    </Channels>
    <Footnote>
      {MARKETING_CONSENT_STATEMENT.footnote} See our{' '}
      <a href={REPOSIT_PRIVACY_POLICY} target="_blank" rel="noopener noreferrer">
        Privacy Notice
      </a>{' '}
      for details.
    </Footnote>
    {children || <></>}
  </RepositCard>
);

export default MarketingPreferencesCard;
